import { render, staticRenderFns } from "./Participationstandard.vue?vue&type=template&id=71716444&scoped=true&"
import script from "./Participationstandard.vue?vue&type=script&lang=js&"
export * from "./Participationstandard.vue?vue&type=script&lang=js&"
import style0 from "./Participationstandard.vue?vue&type=style&index=0&id=71716444&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71716444",
  null
  
)

export default component.exports